import styled, { css } from "styled-components";
import { useEffect, useState } from "react";
import {useClientsState} from "../../store/clients";
import {useTranslation} from "react-i18next";

import bug_icon from "../../assets/svg/bug-report.svg"
import logout from "../../assets/svg/logout.svg";
import draft from "../../assets/svg/draft-icon.svg";
import user from "../../assets/svg/user-icon.svg";
import editUsers from "../../assets/img/edit-users.png"
import editKeywords from "../../assets/svg/keywords-icon.svg"
import sendHistory from "../../assets/svg/send-history-icon.svg";

import {useUserActions, useUserState} from "../../store/user/hooks";
import {useAppActions} from "../../store/app/hooks";
import { useNavigate } from "react-router-dom";
import { media } from "../../assets/styles/breakpoints";

const HeaderView = ()=>{
    const { clients } = useClientsState();
    const {full_name, is_staff} = useUserState()
    const Navigate = useNavigate();
    const {onLogout} = useUserActions();
    const { onSetModal } = useAppActions();
    const {t} = useTranslation();
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        document.body.style.overflow = menuOpen ? "hidden" : "";
        return () => { document.body.style.overflow = ""; };
    }, [menuOpen]);

    const handleAction = (cb: () => void) => {
        cb();
        setMenuOpen(false);
    };

    const actions = (
        <>
            <StyledButton onClick={() => handleAction(() => onSetModal("bug_report"))}>
                <Icon src={bug_icon}/>
                <ButtonTitle>{t("bug-report-title")}</ButtonTitle>
            </StyledButton>
            <StyledButton onClick={() => handleAction(() => onSetModal("drafts"))}>
                <Icon src={draft}/>
                <ButtonTitle>{t("draft-btn-title")}</ButtonTitle>
            </StyledButton>
            {is_staff && (
                <StyledButton onClick={() => handleAction(() => onSetModal("add-user"))}>
                    <Icon src={user}/>
                    <ButtonTitle>{t("edit-user-btn-title")}</ButtonTitle>
                </StyledButton>
            )}
            <StyledButton onClick={() => handleAction(() => onSetModal("client-editor"))}>
                <Icon $wide src={editUsers}/>
                <ButtonTitle>{t("edit-clients-btn-title")}</ButtonTitle>
            </StyledButton>
            <StyledButton onClick={() => handleAction(() => onSetModal("keyword-editor"))}>
                <Icon src={editKeywords}/>
                <ButtonTitle>{t("edit-keywords-btn-title")}</ButtonTitle>
            </StyledButton>
            <StyledButton onClick={() => handleAction(() => onSetModal("emails-history"))}>
                <Icon src={sendHistory}/>
                <ButtonTitle>{t("send-history-icon")}</ButtonTitle>
            </StyledButton>
            {/* {is_staff && (
                <StyledButton onClick={() => handleAction(() => Navigate("/parsers_panel"))}>
                    <ButtonTitle>Parsers Panel</ButtonTitle>
                </StyledButton>
            )} */}
        </>
    );

    return (
        <Container>
            <ClientsTitle>
            מספר לקוחות נוכחי
            <span>{clients.length}</span>
            </ClientsTitle>

            <DesktopActions>
                {actions}
            </DesktopActions>

            <DesktopLogout onClick={onLogout}>
                <Icon src={logout}/>
                <ButtonTitle>{full_name}</ButtonTitle>
            </DesktopLogout>

            <MobileToggle
                aria-label="Open menu"
                $open={menuOpen}
                onClick={() => setMenuOpen((p) => !p)}
            >
                <span/><span/><span/>
            </MobileToggle>

            {menuOpen && (
                <MobileBackdrop onClick={() => setMenuOpen(false)} />
            )}

            <MobileDrawer $open={menuOpen}>
                <MobileUser>
                    <ButtonTitle>{full_name}</ButtonTitle>
                </MobileUser>
                <MobileActions>{actions}</MobileActions>
                <MobileLogout onClick={() => { onLogout(); setMenuOpen(false); }}>
                    <Icon src={logout}/>
                    <ButtonTitle>Logout</ButtonTitle>
                </MobileLogout>
            </MobileDrawer>
        </Container>
    )
}


export default HeaderView;


const Container = styled.div`
  width: 100%;
  padding: 25px 40px;
  min-height: 92px;
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
  align-items: center;
  background: #0058A9;
  position: relative;
  gap: 16px;

  ${media.laptop} {
    padding: 18px 24px;
  }
  ${media.tablet} {
    padding: 14px 16px;
    min-height: 64px;
  }
`

const ClientsTitle = styled.h2`
  color: #fff;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0;
  span{
    padding: 8px;
    color: #FE5912;
  }

  ${media.laptop} {
    font-size: 24px;
  }
  ${media.tablet} {
    font-size: 18px;
    span { padding: 4px; }
  }
  ${media.mobile} {
    font-size: 14px;
    flex: 1;
    span { padding: 2px; }
  }
`


const DesktopActions = styled.div`
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  gap: 34px;
  align-items: center;

  ${media.laptop} {
    gap: 20px;
  }
  ${media.tablet} {
    display: none;
  }
`

const DesktopLogout = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 5px;

  ${media.tablet} {
    display: none;
  }
`


const StyledButton = styled.button`
  border: 0;
  cursor: pointer;
  position: relative;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-left: 30px;
  &:before{
    position: absolute;
    display: block;
    content:"";
    top: 0;
    height: 100%;
    width: 1px;
    left: -30px;
    background: #fff;
  }

  ${media.laptop} {
    margin-left: 20px;
    &:before { left: -20px; }
  }
  ${media.tablet} {
    margin-left: 0;
    flex-direction: row;
    gap: 12px;
    width: 100%;
    padding: 12px 16px;
    justify-content: flex-start;
    border-radius: 6px;
    &:hover { background: rgba(255,255,255,0.08); }
    &:before { display: none; }
  }
`
const ButtonTitle = styled.p`
  color: #FFF;
  object-fit: contain;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0;

  ${media.tablet} {
    text-align: right;
    font-size: 16px;
  }
`

const Icon = styled.img<{ $wide?: boolean }>`
  ${({ $wide }) => $wide && css`width: 50px;`}
  ${media.tablet} {
    width: 28px;
    height: 28px;
    object-fit: contain;
  }
`

const MobileToggle = styled.button<{ $open: boolean }>`
  display: none;
  background: transparent;
  border: 0;
  width: 40px;
  height: 40px;
  cursor: pointer;
  padding: 8px;
  flex-direction: column;
  justify-content: space-between;
  z-index: 1100;

  span {
    display: block;
    height: 3px;
    width: 100%;
    background: #fff;
    border-radius: 2px;
    transition: transform 0.2s ease, opacity 0.2s ease;
  }

  ${({ $open }) => $open && css`
    span:nth-child(1) { transform: translateY(8px) rotate(45deg); }
    span:nth-child(2) { opacity: 0; }
    span:nth-child(3) { transform: translateY(-8px) rotate(-45deg); }
  `}

  ${media.tablet} {
    display: flex;
  }
`

const MobileBackdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  z-index: 1050;
  display: none;

  ${media.tablet} {
    display: block;
  }
`

const MobileDrawer = styled.aside<{ $open: boolean }>`
  display: none;

  ${media.tablet} {
    display: flex;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    width: 280px;
    max-width: 85vw;
    background: #0058A9;
    z-index: 1080;
    flex-direction: column;
    padding: 70px 12px 24px;
    transform: ${({ $open }) => ($open ? "translateX(0)" : "translateX(100%)")};
    transition: transform 0.25s ease;
    overflow-y: auto;
    box-shadow: -4px 0 12px rgba(0,0,0,0.2);
  }
`

const MobileUser = styled.div`
  padding: 8px 16px 16px;
  border-bottom: 1px solid rgba(255,255,255,0.2);
  margin-bottom: 8px;
  text-align: right;
`

const MobileActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`

const MobileLogout = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 12px;
  padding: 14px 16px;
  border-top: 1px solid rgba(255,255,255,0.2);
  margin-top: 8px;
`
